import { render, staticRenderFns } from "./WhatDevelopersShouldKnow.vue?vue&type=template&id=ed019202&scoped=true"
import script from "./WhatDevelopersShouldKnow.vue?vue&type=script&lang=js"
export * from "./WhatDevelopersShouldKnow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed019202",
  null
  
)

export default component.exports